module.exports = __webpack_public_path__ + "static/img/SpeProBg.53d5695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SpeProBg.png
// module id = /vC1
// module chunks = 7